<template>
  <section class="hr-closing" aria-label="Баннеры и сервисы">
    <div class="hr-container">
      <div class="index-banners hr-closing__banners">
        <div class="index-banners__inner">
          <div
            v-for="banner in banners"
            :key="banner.href"
            class="index-banners__item"
          >
            <a
              class="index-banners__link"
              :href="banner.href"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="index-banners__img"
                :src="banner.src"
                :alt="banner.alt"
                :width="banner.width"
                :height="banner.height"
                loading="lazy"
              >
            </a>
          </div>
        </div>
      </div>
    </div>

    <GosuslugiBanner />
  </section>
</template>

<script>
import GosuslugiBanner from '@/components/GosuslugiBanner.vue'
import botMax from '@/assets/img/banners/bot_max.jpg'
import vasheZdor from '@/assets/img/banners/vashe_zdor.jpg'
import zdravKontrol from '@/assets/img/banners/zdrav_kontrol.png'

export default {
  name: 'HrClosingBanners',
  components: { GosuslugiBanner },
  data() {
    return {
      banners: [
        {
          href: 'https://max.ru/kvrachu_zdravalt_bot',
          src: botMax,
          alt: 'Баннер: чат-бот в Макс',
          width: 350,
          height: 82,
        },
        {
          href: 'https://lk.zdravalt.ru/',
          src: vasheZdor,
          alt: 'Баннер: ваше здоровье',
          width: 350,
          height: 76,
        },
        {
          href: 'https://max.ru/join/jTw1eYuedaUYD5k3aH1_kqwBmhe9CUK1sR1jYIuHJ_k',
          src: zdravKontrol,
          alt: 'Баннер: чат «Алтайский край. Здоровье»',
          width: 350,
          height: 89,
        },
      ],
    }
  },
}
</script>
